// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1736927137651
      var cssReload = require("../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./config/module-publish/resources-cvrez/css/main.scss
// module id = 502
// module chunks = 6